export default __webpack_public_path__ + "static/media/11.efae3527.jpg";